import { Badge, BlockStack, Box, Button, Card, IndexTable, InlineStack, Modal, Page, Pagination, Tabs, Text, TextField, Grid, Link, Spinner, Divider } from '@shopify/polaris';
import React, { useEffect, useRef, useState } from 'react';
import { DI, DIProps } from '../../../Core';

interface props extends DIProps {
    totalProductCount: string
    duplicate_sku_count: number
}
const Bdapanel = (props: props) => {
    const [totalcount, settotalcount] = useState<any>(0);
    const [totalParentcount, settotalParentcount] = useState<any>(0);
    const [totalChildcount, settotalChildcount] = useState<any>(0);
    const [loader, setLoader] = useState<boolean>(true);
    const [productStatus, setProductStatus] = useState([
        { id: 'inactive', status: 'Inactive', items: '0' },
        { id: 'not_listed', status: 'Not Listed', items: '0' },
        { id: 'active', status: 'Active', items: '0' },
        { id: 'incomplete', status: 'Incomplete', items: '0' }
    ])
    const [parentproductStatus, setParentProductStatus] = useState([
        { id: 'not_listed', status: 'Not Listed', items: '0' },
        { id: 'incomplete', status: 'Incomplete', items: '0' }
    ])

    useEffect(() => {
        statuscount();
    }, [])


    function statuscount() {
        let temp: any = JSON.parse(JSON.stringify([...productStatus]));
        let tempped: any = JSON.parse(JSON.stringify([...parentproductStatus]));
        props.di.GET("amazon/product/getSkuCount", { useRefine: true, productOnly: true, getErrorCount: true })
            .then((data: any) => {
                if (data?.success) {
                    setLoader(false)
                    data?.data?.forEach((ele: any) => {
                        temp.forEach((element: any) => {
                            if (element?.status == 'Inactive') {
                                element.items = ele?.InactiveProduct
                            }
                            if (element?.status == 'Not Listed') {
                                element.items = ele?.NotListedChild
                            }
                            if (element?.status == 'Active') {
                                element.items = ele?.ActiveProduct
                            }
                            if (element?.status == 'Incomplete') {
                                element.items = ele?.IncompleteProduct
                            }

                        })
                        tempped.forEach((val: any) => {
                            if (val?.status == 'Incomplete') {
                                val.items = ele?.IncompleteProduct
                            }
                            if (val?.status == 'Not Listed') {
                                val.items = ele?.NotListedParent
                            }
                        })
                        setProductStatus([...temp])
                        setParentProductStatus([...tempped])
                        settotalcount(ele?.totalProduct)
                        settotalParentcount(ele?.ParentCount)
                        settotalChildcount(ele?.ChildCount)
                    })
                }
            })
    }
    return (
        <Card roundedAbove='sm'>
            <BlockStack gap="200">
                <InlineStack gap="300" blockAlign='center'>
                    <Text variant="headingMd" as="h6">{("Parent,Child and Simple SKU Count")}</Text>{loader ? <Spinner accessibilityLabel="Small spinner example" size="large" /> :<Badge tone="success"
                        progress="complete"
                        toneAndProgressLabelOverride="Status: Published. Your online store is visible.">{totalcount}</Badge>}
                </InlineStack>
                <BlockStack gap="200">
                    <Divider />
                    <BlockStack gap="300">
                        <BlockStack gap="300">
                            <BlockStack gap="300">
                                <BlockStack gap="100">
                                    <InlineStack gap="300" blockAlign='center'>
                                        <Text variant="headingMd" as="h6" fontWeight='medium'>Child and Simple SKU wise status count</Text>
                                        <Badge tone="success"
                                            progress="complete"
                                            toneAndProgressLabelOverride="Status: Published. Your online store is visible." >{totalChildcount}</Badge>

                                    </InlineStack>
                                    <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">Stay up-to-date with the status of all the product(s) that are enabled in your Shopify store for Amazon by Cedcommerce app to sync on Amazon Marketplace here.</Text>
                                </BlockStack>
                                <Card>
                                    <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                        {
                                            productStatus.map((item, idx) => {

                                                return (
                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} key={item.id}>
                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                            {loader ? <Spinner accessibilityLabel="Small spinner example" size="large" /> : <><Badge tone="info">
                                                                {(item.status)}
                                                            </Badge>
                                                                <Text variant="headingXs" as="h6">{(item.items)}</Text></>}
                                                            <BlockStack gap="200">
                                                            </BlockStack>
                                                        </InlineStack>
                                                    </Grid.Cell>
                                                )
                                            })
                                        }
                                    </Grid>
                                </Card>
                                <BlockStack gap="100">
                                    <InlineStack gap="300">
                                        <Text variant="headingMd" as="h6" fontWeight='medium'>Parent SKU wise status count</Text>
                                        <Badge tone="success"
                                            progress="complete"
                                            toneAndProgressLabelOverride="Status: Published. Your online store is visible.">{totalParentcount}</Badge>

                                    </InlineStack>
                                    <Text variant="headingMd" as="h6" fontWeight='regular' tone="subdued">Stay up-to-date with the status of all the product(s) that are enabled in your Shopify store for Amazon by Cedcommerce app to sync on Amazon Marketplace here.</Text>
                                </BlockStack>
                                <Card>
                                    <Grid columns={{ xs: 2, sm: 2, md: 4, lg: 4, xl: 4 }}>
                                        {
                                            parentproductStatus.map((item, idx) => {
                                                return (
                                                    <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} key={item.id}>
                                                        <InlineStack blockAlign='start' gap="100" wrap={false}>
                                                            {loader ? <Spinner accessibilityLabel="Small spinner example" size="large" /> : <><Badge tone="info">
                                                                {(item.status)}
                                                            </Badge>
                                                                <Text variant="headingXs" as="h6">{(item.items)}</Text></>}
                                                            <BlockStack gap="200">
                                                            </BlockStack>
                                                        </InlineStack>
                                                    </Grid.Cell>
                                                )
                                            })
                                        }
                                    </Grid>
                                </Card>
                            </BlockStack>
                        </BlockStack>
                    </BlockStack>
                </BlockStack>
            </BlockStack>
        </Card>
    );
}

export default DI(Bdapanel);